import React, { useContext, useEffect, useState } from 'react';

import parse from 'html-react-parser';
import { useHistory, useParams } from 'react-router-dom';
import OrderFunctions from '../../../../../MyFunctions/OrderFunctions';
import Translator from '../../../../../MyFunctions/Translator';
import MyDateTime from '../../../../MySections/TimeSections/MyDateTime';
import InvoiceTable from './InvoiceTable';
import InvoiceProductsPrint from './InvoiceProductsPrint';
import ConnUrls from '../../../../../MyConns/Connections/ConnectURL';
import { TheMasterContext } from '../../../../MyContexts/Master_Context';


const InvoicePrint = (props) => {

    const [theMaster, setTheMaster] = useContext(TheMasterContext);


    const [theCss, setTheCss] = useState();
    const [forKitchen, setForKitchen] = useState(props.forKitchen);

    let idParam = useParams();

    const history = useHistory();


    useEffect(() => {
        setForKitchen(props.forKitchen)
    }, [props.forKitchen])

    const getAddress =
        <>
            <div><span>עיר: </span>
                <span className="bold">{props.theOrder.deliveryAddress?.city}</span>
            </div>
            <div className="fullRow">
                <div className="onRight">
                    <span>רחוב: </span>
                    <span className="bold">{props.theOrder.deliveryAddress?.street}</span>
                </div>
                <div className="onRight spaceMargeRight_10">
                    <span>מספר: </span>
                    <span className="bold">{props.theOrder.deliveryAddress?.num}</span>
                </div>
            </div>

            <div className="fullRow">
                {props.theOrder.deliveryAddress?.appartment &&
                    props.theOrder.deliveryAddress?.appartment !== "" &&
                    <div className="onRight">
                        <span>דירה: </span>
                        <span className="bold">{props.theOrder.deliveryAddress?.appartment}</span>
                    </div>
                }
                {props.theOrder.deliveryAddress?.ent &&
                    props.theOrder.deliveryAddress?.ent !== "" &&
                    <div className="onRight spaceMargeRight_10">
                        <span>כניסה: </span>
                        <span className="bold">{props.theOrder.deliveryAddress?.ent}</span>
                    </div>
                }
            </div>
            <div className="fullRow">
                {props.theOrder.deliveryAddress?.flor &&
                    props.theOrder.deliveryAddress?.flor !== "" &&
                    <div className="onRight">
                        <span >קומה: </span>
                        <span className="bold">{props.theOrder.deliveryAddress?.flor}</span>
                    </div>
                }
                {props.theOrder.deliveryAddress?.remarks &&
                    props.theOrder.deliveryAddress?.remarks !== "" &&
                    <div className="onRight spaceMargeRight_10">
                        <span>הערות: </span>
                        <span className="bold">{props.theOrder.deliveryAddress?.remarks}</span>
                    </div>
                }
            </div>
        </>;



    const clientDetails =
        <>
            <div className={"spac spacePadBig specialRow"}>
                <div className={"fullRow"}>
                    <span>שם הלקוח: </span>
                    <span className="bold">{props.theOrder.user?.firstName}  {props.theOrder.user?.lastName}</span>
                </div>
                <div className={"fullRow"}>
                    <span >טלפון: </span>
                    <span className="bold">{props.theOrder.user?.phone}</span>
                </div>
                {props.theOrder.user?.email != "" ?
                    <div className={"fullRow"}>
                        <span>אימייל: </span>
                        <span className="bold">{props.theOrder.user?.email}</span>
                    </div>
                    : ""}
                {
                    props.theOrder.user?.parentUser ? <div className={"bold"}>נוצר על ידי : {props.theOrder.user?.parentUser.firstName + " " + props.theOrder.user?.parentUser.lastName}</div> : ""
                }
            </div>

        </>;

    return (
        <>
            <div className="printOrderPage">
                <div className={``}>

                    <div className={"fullRow"}>
                        <div className={"onRight posRelative"} >
                            <img className={"printingOrderLogo"}
                                src={ConnUrls.servMediasUrl + theMaster.printingOrderLogo} />
                        </div>
                        <div className={"onRight"}>
                            <div className={"spaceLine"}></div>
                            <div className={"spaceLine"}></div>
                            <div className={"bold bigerr fullRow"}>נפוליאון אשדוד</div>
                            <div className={"spaceLine"}></div>
                            <div className={"bold regular fullRow"}>{`הזמנה מספר: ${props.theOrder?.orderNUM}`}</div>
                            <div className={"spaceLine"}></div>
                            <div className={"bold regular fullRow"}>מועד המסירה:
                                יום {MyDateTime.getDayOfWeekHeb(props.theOrder?.dateToDeliver)} {MyDateTime.getDate(props.theOrder?.dateToDeliver)},
                                בשעה {MyDateTime.getShortTime(props.theOrder?.dateToDeliver)}
                            </div>
                        </div>


                    </div>

                    {!props.forKitchen &&
                        <div className={"fullRow"}>
                            <div className={"grayFrame overflowHid flexIt"}>
                                <div className=" flex-1 onRight">
                                    <div className="fullRow">
                                        <span className="bold big">
                                            {(props.theOrder?.OrderType !== "Take") ? "משלוח" : "איסוף"}
                                        </span>
                                    </div>
                                    {props.theOrder?.OrderType !== "Take" &&
                                        <div className="fullRow specialSpan">
                                            {getAddress}
                                        </div>
                                    }
                                </div>
                                <div className={" flex-1 onLeft specialSpan"}>
                                    <div className="bold big fullRow">
                                        פרטי הלקוח
                                    </div>

                                    {clientDetails}
                                </div>
                            </div>
                        </div>
                    }

                    {props.theOrder?.orderRemarks !== null && props.theOrder?.orderRemarks !== "" &&

                        <div className={"fullRow"}>
                            <div className={"grayFrame"}>
                                <div className="bold bigerr fullRow">
                                    הערות:
                                </div>
                                {/* <div className={"pointing"} onClick={() => setRemarks()}> */}
                                <div>
                                    <div className="big bold margeTop_5">{(props.theOrder?.orderRemarks != null) ? parse(`${props.theOrder.orderRemarks}`) : ""} </div>
                                </div>

                            </div>
                        </div>
                    }


                    {!props.forKitchen ?
                        <InvoiceTable theOrder={props.theOrder} arabic={false} isForPrint={true} />
                        :
                        <InvoiceTable theOrder={props.theOrder} arabic={false} isForKitchen={true} />
                    }

                    {!props.forKitchen &&
                        <div className={"fullRow"}>
                            <div className={"grayFrame overflowHid"}>
                                <div className={"onRight half"}>
                                    <div className="fullRow">
                                        <span className="bold">אופן תשלום:</span>
                                        <span className="bold big spaceRight_5">{OrderFunctions.payingTYpe(props.theOrder)}</span>
                                    </div>

                                    <div className="fullRow">
                                        <span className="bold">סטטוס תשלום:</span>
                                        <span className="bold spaceRight_5">{props.theOrder?.paymentStatus}</span>
                                    </div>

                                    <div className="fullRow">
                                        <span className="bold">סטטוס הזמנה: </span>
                                        <span className="bold spaceRight_5">{props.theOrder?.orderStatus}</span>
                                    </div>
                                </div>

                                <div className={"onRight half"}>
                                    <div className={"fullRow"}>
                                        <span className="bold">יצירת ההזמנה:</span>
                                        <span> {MyDateTime.getDateAndTime(props.theOrder?.dateCreated)}</span>
                                    </div>

                                    {(props.theOrder?.lastUpdate) ?
                                        <>
                                            <div className={"fullRow"}>
                                                <span className="bold">עדכון אחרון: </span>
                                                <span>{MyDateTime.getDateAndTime(props.theOrder?.lastUpdate)}</span>
                                            </div>
                                            <div className={"fullRow"}>
                                                <span className="bold">עודכן ע"י:</span>
                                                <span>{props.theOrder?.lastUpdaterBy || ""}</span>
                                            </div>
                                        </>
                                        : ""}

                                    {(props.theOrder?.dateClosed) ? <>
                                        <br />
                                        <div className="fullRow">
                                            <span className="bold">סגירת ההזמנה:</span>
                                            <span>{MyDateTime.getDateAndTime(props.theOrder?.dateClosed)}</span>
                                        </div>

                                        <div className="fullRow">
                                            <span className="bold">נסגר על ידי:</span>
                                            <span>{props.theOrder?.closedBY}</span>
                                        </div>

                                    </>
                                        : ""}

                                </div>
                            </div>

                        </div>
                    }
                </div>
                <div className={"spaceLine"}></div>
                <div className={"dotedLineBlack"}></div>
                <div className={"spaceLine"}></div>
                <div className={"spaceLine"}></div>
                <div className="centerText">
                    <div className={"spTxt"}>ההזמנה בוצעה על ידי מערכת נפוליאון אשדוד</div>
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
            </div >


        </>

    );
}


export default InvoicePrint;
